import React, { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { set, useForm } from "react-hook-form";
import * as yup from "yup";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { Listbox, Transition } from "@headlessui/react";
import SubmitModal from "../components/SubmitModal";
import Loader from "../components/Loader";

import { useDropdown } from "../store/dropdown-context";

const people = ["شكوى", "استفسار", "طلب خدمة"];
const sourceTypes = ["مكالمة هاتفية", "بطاقة ضمان", "الواتساب", "الموقع الالكتروني", "موظفين الشركة", "اخرى"];
// const people = ['شكوى', 'استفسار'];
let citys = [
  { id: 2, name: "مصراتة" },
  { id: 3, name: "بنغازي" },
];
let suburbs = [
  { id: 1, name: "11يونيو" },
  { id: 2, name: "الحي الاسلامي" },
  { id: 3, name: "السبعة" },
];
let accountTypes = [{ id: 1, name: "SRV" }];

const IncomingCallScreen = () => {
  let { phoneNumber } = useParams();
  let navigate = useNavigate();
  const { citysContext, accountTypeContext, getCitys } = useDropdown();
  const location = useLocation();
  const [xx, setxx] = useState("");
  const [selectedPerson, setSelectedPerson] = useState(people[0]);
  const [selectedSuburb, setSelectedSuburb] = useState();
  const [selectedCity, setSelectedCity] = useState();
  const [selectedSource, setSelectedSource] = useState(sourceTypes[0]);
  const [selectedAccountType, setSelectedAccountType] = useState(
    accountTypes?.length > 0
      ? accountTypes[0]
      : {
          id: 1,
          name: "SRV",
        }
  );
  const [open, setOpen] = useState(false);
  const [loadding, setLoadding] = useState(false);
  const [error, setError] = useState("");
  const [number, setNumber] = useState("");

  const handelSubmitx = (data) => {

    data.source = selectedSource;
 
    if (data) {
      if (selectedPerson === "شكوى") {
        navigate(`/ComplaintFormScreen/${phoneNumber}`, {
          state: {
            account: data,
          },
        });
      } else if (selectedPerson === "استفسار") {
        navigate(`/InquiryFormScreen/${phoneNumber}`, {
          state: {
            account: data,
          },
        });
      } else if (selectedPerson === "طلب خدمة") {
        navigate(`/ServiceRequestFormScreen/${phoneNumber}`, {
          state: {
            account: data,
          },
        });
      }
    } else {
      navigate(`/${phoneNumber}`);
    }
  };

  const schema = yup.object().shape({
    accountCode: yup.string().notRequired(),
    accountType: yup.string(),
    requestType: yup.string(),
    source: yup.string(),
    clientName: yup.string().nullable(),
    phone: yup.string().required(),
    city: yup.string(),
    suburb: yup.string(),
    notes: yup.string(),
    notes2: yup.string(),
    notes3: yup.string(),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    console.log(errors, "errors");
  }, [errors]);

  useEffect(() => {
    setLoadding(true);
    setError("");
    window.scrollTo(0, 0);
    try {
      accountTypes = accountTypeContext;
      getCitys();
      citys = citysContext;
      setValue("accountType", "SRV", {
        shouldValidate: true,
      });
      if (location.state) {
        console.log(location.state.account);
        setValue("accountCode", location.state.account.accountCode, {
          shouldValidate: true,
        });
        setValue("phone", location.state.account.phoneLocal, {
          shouldValidate: true,
        });
        setSelectedCity(
          citys.find(
            (element) => element?.name === location?.state?.account?.city
          )
        );
        setxx(location?.state?.account?.stateId);

        setValue("clientName", location.state.account.custName, {
          shouldValidate: true,
        });
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoadding(false);
    }
  }, [citysContext]);

  useEffect(() => {
    setValue("city", selectedCity?.name, {
      shouldValidate: true,
    });
    setValue("suburb", selectedSuburb?.name, {
      shouldValidate: true,
    });
    setValue("requestType", selectedPerson, {
      shouldValidate: true,
    });
    setValue("accountType", selectedAccountType?.name, {
      shouldValidate: true,
    });
  }, [selectedCity, selectedSuburb, selectedPerson, selectedAccountType]);

  const signupHandler = async () => {
    navigate(`/${phoneNumber}`);
  };
  const onSubmit = (data, e) => {
    e.preventDefault();

    handelSubmitx(data);
  };

  useEffect(() => {
    console.log(xx);
    if (xx?.length > 0 && selectedCity?.name !== xx) {
      setSelectedSuburb(
        selectedCity?.Suburbs.find((element) => element?.name === xx)
      );
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = selectedCity?.Suburbs;
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
      } else {
        suburbs = [selectedCity];
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        setSelectedSuburb(suburbs[0]);
      }
    } else {
      if (selectedCity?.Suburbs?.length > 0) {
        suburbs = [selectedCity, ...selectedCity?.Suburbs];
        suburbs.sort(function (a, b) {
          return a.name.localeCompare(b.name, ["ar"]);
        });
        setSelectedSuburb(suburbs[0]);
      } else {
        suburbs = [selectedCity];
        setSelectedSuburb(suburbs[0]);
      }
    }
  }, [selectedCity]);

  return (
    <>
      {loadding ? (
        <div
          className="bg-background-100 min-h-screen h-full flex  w-full align-middle mx-auto justify-center items-center"
          dir="rtl"
        >
          <Loader />
        </div>
      ) : (
        <div
          className="bg-background-100 min-h-screen h-full  w-full flex flex-col container px-36 py-20"
          dir="rtl"
        >
          <div className="mx-auto ">
            <p className="text-title-100 text-xl font-bold">
              نموذج استقبال مكالمة
            </p>
          </div>
          <div className="pt-14">
            <p className="text-title-100 text-xl ">
              رقم الهاتف : {phoneNumber}
            </p>
          </div>
          <div className="flex  pt-12">
            <div className="w-full max-w-xs ">
              <Listbox
                as="div"
                className="space-y-1"
                value={selectedPerson}
                onChange={setSelectedPerson}
              >
                {({ open }) => (
                  <>
                    <Listbox.Label className="block  leading-5 text-title-100 text-xl ">
                      نوع المكالمة
                    </Listbox.Label>
                    <div className="relative">
                      <span className="inline-block w-full rounded-md shadow-sm">
                        <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                          <span className="block truncate">
                            {selectedPerson}
                          </span>
                          <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                            <svg
                              className="h-5 w-5 text-gray-400"
                              viewBox="0 0 20 20"
                              fill="none"
                              stroke="currentColor"
                            >
                              <path
                                d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </Listbox.Button>
                      </span>

                      <Transition
                        show={open}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                      >
                        <Listbox.Options
                          static
                          className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                        >
                          {people.map((person) => (
                            <Listbox.Option key={person} value={person}>
                              {({ selected, active }) => (
                                <div
                                  className={`${
                                    active
                                      ? "text-white bg-blue-600"
                                      : "text-gray-900"
                                  } cursor-default select-none relative py-2 pl-8 pr-4`}
                                >
                                  <span
                                    className={`${
                                      selected ? "font-semibold" : "font-normal"
                                    } block truncate`}
                                  >
                                    {person}
                                  </span>
                                  {selected && (
                                    <span
                                      className={`${
                                        active ? "text-white" : "text-blue-600"
                                      } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                    >
                                      <svg
                                        className="h-5 w-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </div>
            <div className="w-full max-w-xs mx-5">
              <Listbox
                as="div"
                className="space-y-1"
                value={selectedSource}
                onChange={setSelectedSource}
              >
                {({ open }) => (
                  <>
                    <Listbox.Label className="block  leading-5 text-title-100 text-xl ">
                      مصدر التذكرة
                    </Listbox.Label>
                    <div className="relative">
                      <span className="inline-block w-full rounded-md shadow-sm">
                        <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                          <span className="block truncate">
                            {selectedSource}
                          </span>
                          <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                            <svg
                              className="h-5 w-5 text-gray-400"
                              viewBox="0 0 20 20"
                              fill="none"
                              stroke="currentColor"
                            >
                              <path
                                d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </span>
                        </Listbox.Button>
                      </span>

                      <Transition
                        show={open}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                        className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                      >
                        <Listbox.Options
                          static
                          className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                        >
                          {sourceTypes.map((source) => (
                            <Listbox.Option key={source} value={source}>
                              {({ selected, active }) => (
                                <div
                                  className={`${
                                    active
                                      ? "text-white bg-blue-600"
                                      : "text-gray-900"
                                  } cursor-default select-none relative py-2 pl-8 pr-4`}
                                >
                                  <span
                                    className={`${
                                      selected ? "font-semibold" : "font-normal"
                                    } block truncate`}
                                  >
                                    {source}
                                  </span>
                                  {selected && (
                                    <span
                                      className={`${
                                        active ? "text-white" : "text-blue-600"
                                      } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                    >
                                      <svg
                                        className="h-5 w-5"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                      >
                                        <path
                                          fillRule="evenodd"
                                          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                          clipRule="evenodd"
                                        />
                                      </svg>
                                    </span>
                                  )}
                                </div>
                              )}
                            </Listbox.Option>
                          ))}
                        </Listbox.Options>
                      </Transition>
                    </div>
                  </>
                )}
              </Listbox>
            </div>
          </div>
          <div className="py-12">
            <p className="text-title-100 text-xl">بيانات العميل</p>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-col space-y-4">
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">رقم العميل</span>
                  </label>
                  <input
                    disabled
                    name="accountCode"
                    {...register("accountCode")}
                    type="accountCode"
                    // value={number}
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.accountCode?.message}
                  </p>
                </div>
                {/* <div>
                  <label htmlFor='' className=' text-title-100 text-md block'>
                    <span className='px-1'>نوع الحساب</span>
                  </label>
                  <input
                    name='accountType'
                    {...register('accountType')}
                    type='accountType'
                    className='w-full p-2 border border-gray-300 rounded mt-1'
                  />
                  <p className=' opacity-50 text-s'>
                    {errors?.accountType?.message}
                  </p>
                </div> */}
                <div className="flex ">
                  <div className="w-full  ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedAccountType}
                      onChange={setSelectedAccountType}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            نوع الحساب
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedAccountType?.name}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {accountTypes?.map((city) => (
                                  <Listbox.Option key={city?.name} value={city}>
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {city?.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{" "}
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">الاسم</span>
                  </label>
                  <input
                    name="clientName"
                    {...register("clientName")}
                    type="clientName"
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">
                    {errors?.clientName?.message}
                  </p>
                </div>
                <div>
                  <label htmlFor="" className=" text-title-100 text-md block">
                    <span className="px-1">رقم الهاتف</span>
                  </label>
                  <input
                    name="phone"
                    {...register("phone")}
                    type="phone"
                    defaultValue={phoneNumber}
                    className="w-full p-2 border border-gray-300 rounded mt-1"
                  />
                  <p className=" opacity-50 text-s">{errors?.phone?.message}</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="flex ">
                  <div className="w-full  ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedCity}
                      onChange={setSelectedCity}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            المدينة
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedCity?.name}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {citys?.map((city) => (
                                  <Listbox.Option key={city?.name} value={city}>
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {city?.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>{" "}
                <div className="flex  ">
                  <div className="w-full  ">
                    <Listbox
                      as="div"
                      className="space-y-1"
                      value={selectedSuburb}
                      onChange={setSelectedSuburb}
                    >
                      {({ open }) => (
                        <>
                          <Listbox.Label className="block  leading-5 text-title-100 text-md ">
                            الضاحية
                          </Listbox.Label>
                          <div className="relative">
                            <span className="inline-block w-full rounded-md shadow-sm">
                              <Listbox.Button className="cursor-default relative w-full rounded-md border border-gray-300 bg-white pr-3 pl-10 py-2 text-right focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                <span className="block truncate">
                                  {selectedSuburb?.name}
                                </span>
                                <span className="absolute inset-y-0 left-0 flex items-center pr-2 pointer-events-none">
                                  <svg
                                    className="h-5 w-5 text-gray-400"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    stroke="currentColor"
                                  >
                                    <path
                                      d="M7 7l3-3 3 3m0 6l-3 3-3-3"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </span>
                              </Listbox.Button>
                            </span>

                            <Transition
                              show={open}
                              leave="transition ease-in duration-100"
                              leaveFrom="opacity-100"
                              leaveTo="opacity-0"
                              className="absolute mt-1 w-full rounded-md bg-white shadow-lg"
                            >
                              <Listbox.Options
                                static
                                className="max-h-60 rounded-md py-1 text-base leading-6 shadow-xs overflow-auto focus:outline-none sm:text-sm sm:leading-5"
                              >
                                {suburbs.map((suburb) => (
                                  <Listbox.Option
                                    key={suburb?.name}
                                    value={suburb}
                                  >
                                    {({ selected, active }) => (
                                      <div
                                        className={`${
                                          active
                                            ? "text-white bg-blue-600"
                                            : "text-gray-900"
                                        } cursor-default select-none relative py-2 pl-8 pr-4`}
                                      >
                                        <span
                                          className={`${
                                            selected
                                              ? "font-semibold"
                                              : "font-normal"
                                          } block truncate`}
                                        >
                                          {suburb?.name}
                                        </span>
                                        {selected && (
                                          <span
                                            className={`${
                                              active
                                                ? "text-white"
                                                : "text-blue-600"
                                            } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                                          >
                                            <svg
                                              className="h-5 w-5"
                                              xmlns="http://www.w3.org/2000/svg"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clipRule="evenodd"
                                              />
                                            </svg>
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  </Listbox.Option>
                                ))}
                              </Listbox.Options>
                            </Transition>
                          </div>
                        </>
                      )}
                    </Listbox>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="col-span-2">
                  <label htmlFor="" className=" text-title-100 text-md block ">
                    <span className="px-1 ">ملاحظات 1</span>
                  </label>
                  <textarea
                    rows="4"
                    className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                    placeholder=""
                    name="notes"
                    {...register("notes")}
                  ></textarea>
                  <p className=" opacity-50 text-s">{errors?.notes?.message}</p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="col-span-2">
                  <label htmlFor="" className=" text-title-100 text-md block ">
                    <span className="px-1 ">ملاحظات 2</span>
                  </label>
                  <textarea
                    rows="4"
                    className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                    placeholder=""
                    name="notes2"
                    {...register("notes2")}
                  ></textarea>
                  <p className=" opacity-50 text-s">
                    {errors?.notes2?.message}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-44">
                <div className="col-span-2">
                  <label htmlFor="" className=" text-title-100 text-md block ">
                    <span className="px-1 ">ملاحظات 3</span>
                  </label>
                  <textarea
                    rows="4"
                    className="block p-2.5 w-full text-sm text-gray-900 bg-white rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
                    placeholder=""
                    name="notes3"
                    {...register("notes3")}
                  ></textarea>
                  <p className=" opacity-50 text-s">
                    {errors?.notes3?.message}
                  </p>
                </div>
              </div>
            </div>
            <div className="pt-12 justify-center flex">
              <button
                type="submit"
                className="text-white bg-button-100    font-medium  text-sm px-10 py-2.5 mr-2 mb-2    "
              >
                انشاء
              </button>

              <button
                type="button"
                className="text-white bg-button-200    font-medium  text-sm px-10 py-2.5 mr-2 mb-2    "
                onClick={() => signupHandler()}
              >
                الغاء
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
};

export default IncomingCallScreen;
